export default __webpack_public_path__ + "static/media/1982.98136206.png";